import { sendGTMEvent } from '@next/third-parties/google';

interface TrackEventOptions {
  feature: string;
  action: string;
  params?: Record<string, unknown>;
  isKeyEvent?: boolean;
}

export function trackEvent({ feature, action, params = {}, isKeyEvent }: TrackEventOptions) {
  const payload: Record<string, unknown> = { feature, action, ...params };
  if (isKeyEvent) payload.key_event = true;
  sendGTMEvent({ event: 'mkg-site-event', ...payload });
}
